<template>
  <div class="home">
      <!--
              controls
              indicators
      -->
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide :img-src="(appWidth<=768)?require('@/assets/img/digital_house_blue_mobile_1.png'):require('@/assets/img/digital_house_blue.jpg')">
      <!-- <b-carousel-slide :img-src="(windowWidth<=768)?require('@/assets/img/back-house_mobile_4.png'):require('@/assets/img/back-house.png')"> -->
        <!--
          back-house_mobile_4.png
          
          back-house.png
          digital_house_blue.jpg 
          back_house_1.jpg
          house-remax.jpg
        -->
        <div class="avatar">
          <img src="@/assets/img/andreja_rausl_part_1.png" alt="AndrejaRaušl" />
        </div>
        <div class="avatar-text">
          {{ agentName }}<br>
          {{ $t('nep-agent') }}<br>
          <a :href="'tel:'+telNumber" class="nep-phone-nb">{{ telNumber }}</a>
        </div>
        <div class="nep-main-text" v-html="$t('expert-advice')"></div>
        <!-- <div class="nep-btn" style="top:3vw; width:23vw;border-radius: 2vw;box-shadow: 0 0 15px 5px rgba(255,0,0,0.8);"> -->
        <div v-if="blogVisible" class="nep-btn blog-btn">
          <div class="nep-btn-arrow-rght">
            <i class="fas fa-caret-right"></i>
          </div>
          <div class="nep-btn-blog-text">
            BLOG
          </div>
          <div class="nep-btn-arrow-lft">
            <i class="fas fa-caret-left"></i>
          </div>
        </div>
        <div class="breathing nep-btn contact-btn" @click="scrollDown('hook-sell')">
          <div class="nep-btn-arrow-rght">
            <i class="fas fa-caret-right"></i>
          </div>
          <div class="nep-btn-contact-text">
            {{ $t('contact') }}
          </div>
          <div class="nep-btn-arrow-lft">
            <i class="fas fa-caret-left"></i>
          </div>
        </div>
        <div class="nep-btn real-estate-sell" @click="scrollDown('hook-sell')">
          <div class="nep-btn-icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="nep-btn-text"> {{ $t('real-estate-sell') }}</div>
          <div class="nep-btn-arrow">
            <i class="fas fa-caret-right arrow-right"></i>
          </div>
        </div>
        <div class="nep-btn real-estate-search" @click="scrollDown('hook-search')">
          <div class="nep-btn-icon">
            <i class="fas fa-key"></i>
          </div>
          <div class="nep-btn-text"> {{ $t('real-estate-search') }}</div>
          <div class="nep-btn-arrow">
            <i class="fas fa-caret-right arrow-right"></i>
          </div>
        </div>
        <div class="nep-btn real-estate-rent">
          <div class="nep-btn-icon">
            <i class="fas fa-bed"></i>
          </div>
          <div class="nep-btn-text"> {{ $t('real-estate-rent') }}</div>
          <div class="nep-btn-arrow">
            <i class="fas fa-caret-right arrow-right"></i></div>
        </div>
        <div class="nep-btn real-estate-agent" @click="scrollDown('hook-agent')">
          <div class="nep-btn-icon">
            <i class="fas fa-question"></i>
          </div>
          <div class="nep-btn-text"> {{ $t('main-title-line') }}</div>
        </div>
        <div class="real-estate-agency">
          <a href="https://www.re-max.si/sl-si/posredniki/podravje/ptuj/andreja-rausl/490151045" target="_blank">
            <img class="remax-balloon" :src="require('@/assets/img/remax_balloon.png')"/>
            <img class="remax-petovio-logo" :src="require('@/assets/img/remax-petovio.png')"/>
          </a>
        </div>
      </b-carousel-slide>
    </b-carousel>
    <b-container class="prl-outside px-4">
      <b-row>
      	<b-col id="hook-agent" cols="12" class="text-center mt-3 mb-1">
	        <p class="mt-3 main-title-text" v-html="$t('main-title')"></p>
      	</b-col>
      </b-row>
      <b-row v-for="(option, key) in options" :key="'opt-' + key" class="nep-opt-main mb-3 p-0">
      	<b-col cols="12" md="4" class="option-title text-center" :style="{backgroundImage: 'url(' + appRoot + option.image + ')'}">
          <div class="w-100 center-text options-title" v-html="option.title"></div>
      	</b-col>
      	<b-col cols="12" md="8" class="text-center mt-3 mb-0 pb-3 options-text" v-html="option.description"></b-col>
      </b-row>
 		  <!-- <b-button class="gera-btn mx-auto mt60" @click="$router.push('/company')" style="width:300px;">{{$t('moreabout')}}</b-button> -->
    </b-container>
		<div id="hook-search" class="mt-5 p-3 text-center bg-full-image" :style="{backgroundImage: 'url(' + appRoot + buyingHousePic + ')'}">
        {{ $t('real-estate-search') }}<br>
        <span class="nep-sub-title">{{ $t('from-offer') }}</span>
    </div>
    <b-container class="prl-outside px-4 mt-4">
      <homeArticle v-for="(estate, key) in sellingEstates" :key="'sell-' + key" :estate="estate"></homeArticle>
      <b-row>
        <b-col cols="12" class="breathing mt-2 mb-1 btn-not-find" style="min-height:25px;" @click="scrollDown('hook-sell')">
<!--
          <div class="nep-btn-arrow-rght">
            <i class="fas fa-caret-right"></i>
          </div>
-->
          <div class="fluid-text p-1" style="line-height:1.2">
            {{ $t('didnt-find') }}<br>
            <i class="fas fa-chevron-down"></i> <i class="fas fa-chevron-down"></i> <i class="fas fa-chevron-down"></i>
             <!--<br v-if="appWidth<=768"> Povežite se z nami! -->
          </div>
<!--
          <div class="nep-btn-arrow-lft">
            <i class="fas fa-caret-left"></i>
          </div>
-->
        </b-col>
      </b-row>

<!-- 
      <b-row class="">
        <a :href="estate.link">
          <b-col v-for="(estate, key) in sellingEstates" :key="'_sell_'+key" cols="12" md="4" class="px-4 py-2 text-left bg-full-image"  :style="{backgroundImage: 'url(' + estate.image + ')'}" style="overflow:hidden;text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black; height:15vw; border-radius: 1vw; color:white;font-size:1.1vw;">
            <div class="w-100" v-html="estate.title"></div>
          </b-col>
        </a>
      </b-row>
 -->
    </b-container>

		<div id="hook-sell" class="mt-4 p-3 text-center bg-full-image" :style="{backgroundImage: 'url(' + appRoot + sellingHousePic + ')'}">
      <!-- Prodajate/oddajate nepremičnino?<br> -->
      {{ $t('connect') }}<br>
      <span class="nep-sub-title">{{ $t('tell-us') }}</span>
    </div>
    <b-container class="prl-outside px-4">  
      <b-row align-h="around" v-if="appWidth>768">
          <b-col cols="12" class="p-2 text-center" style="font-size: clamp(1rem, 1.4vw + 0.5rem, 3rem);">
            <span style="font-weight:bold;">{{ $t('we-are-sure') }}</span> {{ $t('you-will-be') }}
          </b-col>
      </b-row>
      <b-row align-h="around">
        <b-col v-if="appWidth<=768" cols="5" class="p-2">
          <img class="img-hor" style="width:35vw;" :src="require('@/assets/img/andreja_rausl_1.png')"/>
        </b-col>
        <b-col cols="7" md="12" class="p-2" style="font-size: clamp(0.9rem, 1.5vw, 4rem);text-align:left;">
          <b-col v-if="appWidth<=768" cols="12" class="p-2 text-center mb-4" style="font-size: clamp(1rem, 1.4vw + 0.5rem, 3rem);">
            <span style="font-weight:bold;">{{ $t('we-are-sure') }}</span> {{ $t('you-will-be') }}
          </b-col>
          <div class="w-100 text-center mt-3">
            {{ $t('call') }} <br v-if="appWidth<=768">
            <a :href="'tel:'+telNumber" style="cursor:pointer;text-decoration: underline;">{{ telNumber }}</a><br>
            {{ $t('send-us') }}<br><br>
            <span style="font-weight:bold;">{{ $t('respond-to-you') }}</span>
          </div>
        </b-col>
        <b-col cols="12" md="7" class="p-2">
          <homeContactForm />
        </b-col>
        <b-col v-if="appWidth>768" cols="12" md="5" class="p-2">
          <img class="img-hor" style="width:20vw;" :src="require('@/assets/img/andreja_rausl_1.png')"/>
        </b-col>
      </b-row>
    </b-container>
		<div v-if="testiMonials.length > 0" id="hook-sell2" class="mt-5 p-3 text-center bg-full-image" :style="{backgroundImage: 'url(' + appRoot + testimonHousePic + ')'}">
      {{ $t('testimonials') }}
    </div>
    <b-container v-if="testiMonials.length > 0" class="prl-outside px-4 text-left">  
      <b-row class="mt-3" align-h="around" v-for="(test, key) in testiMonials" :key="key">
        <b-col cols="3">{{ test.customer }}</b-col>
        <b-col cols="9">
          {{ test.date }}
          <blockquote>{{ test.text }}</blockquote>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import homeArticle from './home/home-article.vue'
import homeContactForm from './home/home-contact-form.vue'
import { mapState } from 'vuex'
export default {
  name: 'Home',
  metaInfo: {
    title: 'Nep-dom.si - Licencirana nepremičninska posrednica',
    meta: [
      { description: 'Licencirana nepremičninska posrednica' },
      { keywords: 'Andreja Raušl, nepremičnine, posrednica, licencirana,' },
      // { property: 'og:site_name', content: 'Nep-dom.si' },
      // { property: 'og:title', content: 'Nep-dom.si - nepremičninsa agencija' },
      // { property: 'og:description', content: 'Strokovno svetovanje pri prodaji nakupu in najemu vaše sanjske nepremičnine' },
      // { property: 'og:url', content: 'https://nep-dom.si' },
      // { property: 'og:image', content: 'http://nep-dom.si/img/back-house.png' },
      // { property: 'og:type', content: 'website' },
      { name: 'robots', content: 'index,follow' }
    ]
  },
  components: {
    homeArticle,
    homeContactForm
  },
  data () {
    return {
      title: 'Nep-dom.si - Licencirana nepremičninska posrednica',
      agentName: 'Andreja Raušl, mag. manag.',
      telNumber: '+386 41 223 770',
      agentDescription: this.$t('nep-agent'),
      blogVisible: false,
      testiMonials: [
        // { date: '12.2024', customer: 'Sata in Janko Caković', text: 'Zelo pozitivna in prijetna izkušnja, brez stresa od začetka do prodaje. Kupca našli v parih dneh. Svetovanje na profesionalnem nivoju. Vsak nasvet se je izkazal za pravilen in dobro premišljen. Odlično opravljeno!' },
        // { date: '12.2024', customer: 'Sata in Janko Caković', text: 'Zelo pozitivna in prijetna izkušnja, brez stresa od začetka do prodaje. Kupca našli v parih dneh. Svetovanje na profesionalnem nivoju. Vsak nasvet se je izkazal za pravilen in dobro premišljen. Odlično opravljeno!' },
        // { date: '12.2024', customer: 'Sata in Janko Caković', text: 'Zelo pozitivna in prijetna izkušnja, brez stresa od začetka do prodaje. Kupca našli v parih dneh. Svetovanje na profesionalnem nivoju. Vsak nasvet se je izkazal za pravilen in dobro premišljen. Odlično opravljeno!' }
      ],
      slide: 0,
      sliding: false,
      windowWidth: 1920,
      sellingHousePic: 'img/why-professional_knowledge.jpg',
      buyingHousePic: 'img/why-Real-Estate-Professional-Rules.jpg',
      testimonHousePic: 'img/professinalism_real_estate_cr1.jpg',
      sellingEstates: [
        {
          title: 'HIŠA | PRODAMO',
          priceTag: '55.000€',
          area: '184',
          build: '1924',
          location: 'Središče ob Dravi',
          description: 'Hiša je namenjena za vse, ki si želijo mirno in udobno bivanje sredi narave. Dostop do nepremičnine je po asfaltni ulici. V okolici se nahajajo stanovanjski in kmetijski objekti ter kmetijske površine.',
          link: 'https://www.re-max.si/sl-si/nepremicninski-oglasi/hisa/prodamo/sredisce-ob-dravi/obrez/490151045-4',
          image: 'img/hisa_2.jpg',
          tagID: 0
        },
        {
          title: 'HIŠA | PRODAMO',
          location: 'Lovrenc na Dravskem polju', 
          priceTag: '192.900€',
          area: '160,20',
          build: '1984',
          description: 'Na prodaj je očarljiva hiša v mirni lokaciji Lovrenca na Dravskem polju, Podravje, Slovenija in je vseljiva takoj. S skupno bivalno površino 160,2 kvadratnih metrov je idealna priložnost za posameznike ali pare, ki iščejo mir in bližino narave. <br>Hiša je obdana z veliko zelenico, kjer boste lahko uživali v mirnih trenutkih obkroženi s svežim zrakom in prelepimi razgledi na okoliške travnike.',
          link: 'https://www.re-max.si/sl-si/nepremicninski-oglasi/hisa/prodamo/lovrenc-na-dravskem-polju/490151045-6',
          image: 'img/hisa_3.jpg',
          tagID: 0
        },
        {
          title: 'STANOVANJE | PRODAMO',
          location: 'Kamnica',
          priceTag: '239.900€',
          area: '86,5',
          build: '2008',
          description: 'Sončno in svetlo stanovanje na mirni lokaciji v Kamnici. Notranjost stanovanja je svetla in prostorna zahvaljujoč velikim panoramskim oknom, ki nudi razgled na Pohorje. Kuhinja z jedilnico je opremljena z vsemi potrebnimi aparati in ima svetle delovne površine. Stanovanje je izolirano in zidano z opeko, za ogrevanje pa skrbi etažna plinska peč.',
          link: 'https://www.re-max.si/sl-si/nepremicninski-oglasi/stanovanje/prodamo/kamnica/490151045-7',
          image: 'img/stanovanje_1.jpg',
          tagID: 2
        },
        {
          title: 'HIŠA | PRODAMO',
          location: 'Zgornji Leskovec',
          priceTag: '80.000€',
          area: '142',
          build: '1987',
          description: 'Vzdrževana hiša, vseljiva takoj, v mirni in slikoviti vasici Skorišnjak nedaleč od Ptuja. Ta prostorna 2-nadstropna hiša nudi udobje in sproščenost podeželskega življenja.',
          link: 'https://www.re-max.si/sl-si/nepremicninski-oglasi/hisa/prodamo/zgornji-leskovec/490151045-1',
          image: 'img/hisa_1.jpg',
          tagID: 3
        },
      ],
      options: [
        { title: this.$t('point1'), description: this.$t('desc1'), image: 'img/why-professional_knowledge.jpg' },
        { title: this.$t('point2'), description: this.$t('desc2'), image: 'img/why-house_hand_shake.jpg' },
        { title: this.$t('point3'), description: this.$t('desc3'), image: 'img/why-one_on_one_meeting.jpg' },
        { title: this.$t('point4'), description: this.$t('desc4'), image: 'img/why-networking.jpeg' },
        { title: this.$t('point5'), description: this.$t('desc5'), image: 'img/why-time.png' }
      ]
    }
  },
  methods: {
  	scrollDown(elementID) {
      const element = document.getElementById(elementID)
      const { top: t, left: l } = element.getBoundingClientRect()
      const { scrollX, scrollY } = window
      const topPos = t + scrollX
  		window.scrollBy(scrollY, topPos)
  	},
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    }
  },
  created () {
  },
  computed: {
    ...mapState({
      appWidth: state => state.appWidth,
      appRoot: state => state.app_root
    //   userData: state => state.userData,
    //   entryTypes: state => [{ id: null, text: '' }, ...state.entryTypes],
    //   tsTypes: state => [{ id: null, text: '' }, ...state.tsTypes],
    //   holidays: state => state.holidays,
    //   localeData: state => state.localeData,
    //   isAdmin: state => (state.userData.isAdmin === 1)
    })
  }
}
</script>
<style>
html {
  scroll-behavior: smooth;
}
blockquote {
  background: #f9f9f9;
  border-left: 10px solid #ccc;
  margin: 1.5em 10px;
  padding: 0.5em 10px;
}
button {
  transition: transform 0.3s ease;
}
button:hover, .btn-more:hover {
  transform: scale (1.1);
}
blockquote:before {
  color: #ccc;
  content: open-quote;
  font-size: 4em;
  line-height: 0.1em;
  margin-right: 0.25em;
  vertical-align: -0.4em;
  content: '“';
}
blockquote p {
  display: inline;
}
/* Blured image */
/* 
.carousel-item img {
  filter: blur(2px);
  -webkit-filter: blur(2px);
}
 */
.breathing {
   -webkit-animation: breathing 5s ease-out infinite normal;
    animation: breathing 5s ease-out infinite normal;
    -webkit-font-smoothing: antialiased;
    text-align: center;    
}

@-webkit-keyframes breathing {
  0% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }

  100% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
}

@keyframes breathing {
  0% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }

  100% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }
}

.fluid-text { font-size: clamp(1rem, .2vw + 1rem, 3rem); }
.img-hor {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}
.btn-more {
  font-size: clamp(.8rem, 0.1vw + 0.5rem, 3rem);width:30%;float:right;
  position:relative;cursor:pointer;color:black;text-align:center;border-radius: 2vw;
  box-shadow: 0 0 5px 1px rgba(0, 55, 143, 0.8);
  /* box-shadow: 0 0 15px 5px rgba(0, 55, 143, 0.8); */
  transition: transform 0.3s ease;
}
.btn-more:hover {
  transform: scale (1.1);
}
div.btn-more:not(:has(div.btn-not-find:hover)):hover {
  box-shadow: 0 0 10px 2px rgba(255,0,0,0.8);
}
.btn-not-find {
  position:relative;cursor:pointer;font-size:1.5vw;color:black;text-align:center;border-radius: 2vw;box-shadow: 0 0 15px 5px rgba(0, 55, 143, 0.8);
}
div.btn-not-find:not(:has(div.btn-not-find:hover)):hover {
  box-shadow: 0 0 10px 2px rgba(255,0,0,0.8);
}
.bg-full-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-size: clamp(1rem, 4.5vw + 0.5rem, 3.5rem ); /* 1rem, 4.5vw + 0.5rem, 4.5rem */
  overflow: hidden;
}
.nep-sub-title {
  color:white;font-size: clamp(1rem, 1.5vw + 0.5rem, 3rem);
}
.nep-article-texts {
  position:relative;font-size: clamp(1rem, .2vw + 0.5rem, 3rem);
}
.nep-article-data {
  float:left;position:relative;width:50%;
}
.center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.carousel-caption {
  top:0;
  /*left:0; */
  width: 100vw;
  height: 100vh;
}
.avatar {
	width: 18vw;
	height: 18vw;
	box-sizing: border-box;
	border: 3px white solid;
	border-radius: 50%;
	overflow: hidden;
	box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);
	transform: translatey(0px);
	animation: float 6s ease-in-out infinite;
  background: rgb(26, 188, 156);
	background: -moz-linear-gradient(-45deg, rgb(26, 183, 188) 0%, rgb(64, 41, 180) 100%);
	background: -webkit-linear-gradient(-45deg, rgba(26, 183, 188, 1) 0%, rgba(64, 41, 180, 1) 100%);
	background: linear-gradient(135deg, rgba(26, 183, 188, 1) 0%, rgba(64, 41, 180, 1) 100%);
  margin-left: -7vw;
  margin-top: 19vw;
}
.avatar img {
	width: 100%; height: auto; margin-top:1.5vw;
}
.avatar-text {
  margin-left: -15vw;
	width: 35vw;
	height: auto;
	box-sizing: border-box;
	overflow: hidden;
	transform: translatey(2vw);
  font-size: 1.6vw;
	/* animation: float 6s ease-in-out infinite; */
  text-shadow: 0 0 20px #fff, 0 0 30px #070029, 0 0 40px #070029, 0 0 50px #070029, 0 0 60px #070029, 0 0 70px #070029, 0 0 80px #070029;
  box-shadow: none;
}
@keyframes float {
	0% {
		box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);
		transform: translatey(0px);
	}
	50% {
		box-shadow: 0 25px 15px 0px rgba(0,0,0,0.2);
		transform: translatey(-5px);
	}
	100% {
		box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);
		transform: translatey(0px);
	}
}
.text-home {
  font-family: Gotham-Thin;
  width:100%;
  /* animation: glow 1s ease-in-out infinite alternate; */
  /* position:absolute; */
  /* bottom: 0;left: -12vw; */
  /* text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #3200e6, 0 0 40px #3200e6, 0 0 50px #3200e6, 0 0 60px #3200e6, 0 0 70px #3200e6; */
  text-shadow: 0 0 20px #fff, 0 0 30px #2a2a2a, 0 0 40px #2a2a2a, 0 0 50px #2a2a2a, 0 0 60px #2a2a2a, 0 0 70px #2a2a2a, 0 0 80px #2a2a2a;
  font-size: 6vw;
  color:white;
  font-weight:100;
  /* text-shadow: none; */
}
@keyframes glow {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #3200e6, 0 0 40px #3200e6, 0 0 50px #3200e6, 0 0 60px #3200e6, 0 0 70px #3200e6;
  }
  
  to {
    text-shadow: 0 0 20px #fff, 0 0 30px #4dcaff, 0 0 40px #4dcaff, 0 0 50px #4dcaff, 0 0 60px #4dcaff, 0 0 70px #4dcaff, 0 0 80px #4dcaff;
  }
}
.home .carousel-control-prev, .home .carousel-control-next {
  width: auto !important;
}
#hook-sell, #hook-sell2 {
  overflow:hidden;text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;color:yellow;
}
#hook-search {
  overflow:hidden;text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;color:yellow;
}
.nep-main-text {
  color:yellow;position:absolute;width:50vw;text-align:left;top:2vw;margin-left:4vw;font-size:2.8vw;line-height:1.5;text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}
.nep-phone-nb {
  color:white; cursor:pointer;text-decoration: underline;
}
.nep-btn {
  position:absolute;background:#00000080;padding-top:5px;padding-bottom:5px;border-radius:10px;cursor:pointer;
  box-shadow: 0 0 15px 5px rgba(255,255,255,0.8);
}
.blog-btn {
  top:3.2vw; right:20vw;width:10vw;border-radius: 2vw;box-shadow: 0 0 15px 5px rgba(255,242,0,0.8);
}
.nep-btn-blog-text { 
  font-size: 1.5vw; width:70%;text-align: center; float:left;padding-left:2.7vw;
}
.nep-btn-contact-text {
  width:100%;text-align: center; float:left;
}
.contact-btn {
  top:49vw; left:-12.5vw; width:30vw;border-radius: 2vw;box-shadow: 0 0 15px 5px rgba(255,0,0,0.8);
}
.real-estate-sell {
  top:22vw; right:18vw; width:50vw;
}
.real-estate-search {
  top:28vw; right:18vw; width:50vw;
}
.real-estate-rent {
  top:34vw; right:18vw; width:50vw;
}
.real-estate-agent {
  top:40vw; right:18vw; width:50vw;
}
.real-estate-agency {
  position: absolute; top: 53vw; right: 2vw; width: 50vw; height: 5vw;
}
div.nep-btn:not(:has(div.nep-btn:hover)):hover {
  color: yellow;
  box-shadow: 0 0 15px 5px rgba(255, 242, 0, 0.8);
}
.nep-btn-icon {
  float:left;position:relative;width:10%;margin-top:5px; 
}
.nep-btn-text {
  float:left;width:85%;margin-top:3px;margin-left:-30px;font-size:2vw;
}
.nep-btn-arrow {
  position:absolute;right:0vw;width:auto;top:5px;padding-right:1.5vw;
}
.nep-btn-icon i {
  font-size: 2.4vw;
}
.arrow-right {
  font-size: 3vw;
}
.nep-btn-arrow-rght {
  position:absolute; left:1vw;margin-top:-0.2vw;
}
.nep-btn-arrow-lft {
  position:absolute; right:1vw;margin-top:-0.2vw;
}
.nep-btn-arrow-lft i, .nep-btn-arrow-rght i {
  font-size: 200%;
}
.btn-not-find .nep-btn-arrow-lft i, .btn-not-find .nep-btn-arrow-rght i {
  font-size: 125%;
}
.remax-balloon {
  height:100%;margin-top:-5px;
}
.remax-petovio-logo {
  height:100%;
}
.nep-opt-main {
  border:solid 1px #d2d2d2;border-radius: 10px; overflow:hidden;
}
.main-title-text {
  font-size:3vw;
}
.option-title {
  background-position: center; background-repeat: no-repeat; background-size: cover;color:white;padding: 2vw 1vw; text-align: left;
}
.options-title {
  font-size:1.4vw;text-align: center;font-weight:bold;text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}
.options-text {
  font-size:1.25vw;
}
.scrollBtn {
	margin-top:-90px;
	z-index:150;
}
.home-pics {
  float:right;width:35%;height:auto;
}

/* @media only screen and (max-width: 768px) { */
@media only screen and (max-width: 1500px) {
  .btn-not-find .nep-btn-arrow-lft i, .btn-not-find .nep-btn-arrow-rght i {
    font-size: 150%;
  }
}
@media only screen and (max-width: 1200px) {
  .btn-not-find .nep-btn-arrow-lft i, .btn-not-find .nep-btn-arrow-rght i {
    font-size: 175%;
  }
}
@media only screen and (max-width: 992px) {
/*  .nep-btn-arrow-rght {
    top:0.4vw;
  }
  .nep-btn-arrow-lft {
    top:0.4vw;
  } */
  .nep-btn-arrow-rght {
    top:0.2vw;
  }
  .nep-btn-arrow-lft {
    top:0.2vw;
  }
}

@media only screen and (max-width: 768px) {
  .real-estate-agency {
    position: absolute; top: 210vw; right: 13vw; width:100%; height: 10vw;
  }
  .btn-more {
    width:50%;
  }
  .house-pic {
    min-height: 50vw;
  }
  .carousel-caption {
    position:absolute;
    width:100vw;
    top:0;
  }
  .nep-main-text {
    color:yellow;width:90vw;margin-left:-10vw;padding-top:0px;padding-bottom:10px;font-size:7.3vw;line-height:1.3;text-align: right;
  }
  .avatar {
    width: 45vw;
    height: 45vw;
    margin-top:50vw;
    margin-bottom:5vw;
    margin-left: 35vw;
  }
  .avatar img {
    transform: rotateY(180deg);
    /* -webkit-transform: scaleX(-1);
    transform: scaleX(-1);     */
  }
  .avatar-text {
    position:relative;width:90vw;font-size:4vw;text-align:right;margin-left:-10vw;margin-top:-5vw;z-index:15;padding-top:10px;padding-bottom:10px;
    font-weight:bold;
    text-shadow: 0 0 10px #000, 0 0 20px #070029;
  }
  .text-home {
    line-height: 1.2;
    font-size: 9.5vw;
    font-weight: bold;
  }
  .nep-btn {
    width:90%;background:#00000080;padding-top:10px;padding-bottom:10px;border-radius:10px;cursor:pointer;
  }
  .blog-btn {
    display:none;
  }
  .nep-btn-blog-text { 
    font-size: 3vw; width:100%;height:3vw;padding-left:0vw;margin-top:-1.9vw;
  }
  .contact-btn {
    /* display:none; */
    width:45vw;top:93vw;left:-10vw;border-radius:3vw;
  }
  .nep-btn-contact-text {
    font-size: 3vw; width:100%;height:3vw;padding-left:0vw;margin-top:-1.6vw;
  }
  .nep-btn-arrow-rght {
    left:2.5vw;padding-top:0.2vw;
  }
  .nep-btn-arrow-lft {
    right:2.5vw;padding-top:0.2vw;
  }

  .nep-btn-arrow-lft i, .nep-btn-arrow-rght i {
    font-size:4.5vw;
  }
  .real-estate-search {
    top:125vw;right:20vw;width:90vw;
  }
  .real-estate-sell {
    top:140vw;right:20vw;width:90vw;
  }
  .real-estate-rent {
    top:155vw;right:20vw;width:90vw;
  }
  .real-estate-agent {
    top:170vw;right:20vw;width:90vw;
  }

  .nep-btn-icon {
    float:left;position:relative;padding-left:5vw;width:10vw;margin-top:5px; 
  }
  .nep-btn-text {
    float:left;position:relative;width:85%;margin-top:3px;margin-left:0px;font-size:4.7vw;
  }
  .nep-btn-arrow {
    position:absolute;right:0vw;width:auto;top:5px;padding-right:4vw;
  }
  .nep-btn-icon i {
    font-size: 6vw;
  }
  .arrow-right {
    font-size: 8vw; margin-top:1.5vw;
  }
  .main-title-text {
    font-size:8vw;
  }
  .option-title {
    padding: 8vw 2vw;
  }
   .options-title {
    font-size:5vw;
  }
  .options-text {
    font-size:4vw;
  }
  .scrollBtn {
		margin-top:-40px;
	}
	.scrollBtn img {
		width: 40px;
	}
}
</style>
<i18n>
  {
    "sl": {
      "expert-advice": "Strokovno svetovanje pri<br><span style=\"font-weight:bold;\">prodaji, nakupu ali najemu</span><br>vaše sanjske nepremičnine",
      "real-estate-search": "Kupujete nepremičnino?",
      "real-estate-sell": "Prodajate nepremičnino?",
      "real-estate-rent": "Dajate v najem?",
      "main-title": "Zakaj izbrati<br>nepremičninskega posrednika?",
      "main-title-line": "Zakaj izbrati nepremičninskega posrednika",
      "contact": "KONTAKTIRAJTE ME",
      "point1": "STROKOVNO ZNANJE",
      "desc1": "S poglobljenim znanjem o trgu nepremičnin, pravnih postopkih in tržnih trendih in s pravim pristopom <span style=\"font-weight:bold;\">zagotovo hitro</span> najdemo kupca za vašo nepremičnino.",
      "point2": "PROFESIONALNOST",
      "desc2": "Skrbimo za visoko raven storitev in zagotavljamo, da so postopki izvedeni strokovno in v skladu z zakonodajo.",
      "point3": "INDIVIDUALEN PRISTOP",
      "desc3": "Poslušamo vaše potrebe in želje ter s strokovnim znanjem prilagodimo naš pristop za hiter doseg najboljših ciljev oz. realizacijo transakcije.",
      "point4": "MREŽENJE",
      "desc4": "Dostop do široke mreže potencialnih kupcev in prodajalcev povečuje možnost za uspešno in hitro transakcijo.",
      "point5": "PRIHRANEK ČASA",
      "desc5": "Mi vodimo vse postopke prodaje ali nakupa, zato se vi lahko osredotočite na druge pomembnejše stvari. S strokovno podporo in nasveti vas vodimo čez celoten postopek.<br><span style=\"font-weight:bold;\">Poskrbimo, da je izkušnja za vas čimbolj prijetna in brezskrbna.</span>",
      "nep-agent": "Licencirana nepremičninska posrednica",
      "testimonials": "Mnenja naših cenjenih strank",
      "moreabout": "Več o meni",

      "from-offer": "Aktualno iz naše ponudbe",
      "didnt-find": "Niste našli kar iščete?",
      "connect": "Povežite se z nami!",
      "tell-us": "Zaupajte nam vaše želje o nepremični",
      "we-are-sure": "Prepričani smo",
      "you-will-be": ", da boste z našo storitvijo, kot do sedaj vse naše stranke, zagotovo zadovoljni.",
      "call": "Pokličite",
      "send-us": "ali pošljite izpolnjen kontaktni obrazec.",
      "respond-to-you": "Z veseljem se vam bomo odzvali!"

    },
    "de": {
      "expert-advice": "Wir bieten kompetente Beratung bei<br><span style=\"font-weight:bold;\">Verkauf, Kauf oder Vermietung</span><br>Ihrer Traumimmobilie",
      "real-estate-search": "Immobilien suchen?",
      "real-estate-sell": "Immobilien verkaufen?",
      "real-estate-rent": "Mieten Sie?",
      "main-title": "Warum einen<br>Immobilienmakler wählen?",
      "main-title-line": "Warum einen Immobilienmakler wählen",
      "contact": "KONTAKTIEREN MICH",
      "point1": "BERUFLICHES WISSEN",
      "desc1": "Wir verfügen über fundierte Kenntnisse des Immobilienmarktes,<br>der rechtlichen Prozesse und Markttrends.",
      "point2": "INDIVIDUELLER ANSATZ",
      "desc2": "Wir hören auf die Bedürfnisse und Wünsche unserer Kunden und passen<br>unseren Ansatz an, um die besten Ziele zu erreichen.",
      "point3": "PROFESSIONALITÄT",
      "desc3": "Wir stellen ein hohes Serviceniveau sicher und stellen sicher, dass Transaktionen<br>professionell und gesetzeskonform abgewickelt werden.",
      "point4": "NETZWERK",
      "desc4": "Wir haben Zugriff auf ein breites Netzwerk potenzieller Käufer und Verkäufer,<br>was die Chance auf eine erfolgreiche Transaktion erhöht.",
      "point5": "ZEITSPAREND",
      "desc5": "Wir verwalten alle Verkaufs- oder Kaufprozesse, sodass Sie sich<br>auf wichtigere Dinge konzentrieren können.<br>Wir begleiten Sie durch den gesamten Prozess mit professioneller Unterstützung und Beratung.<br>Wir machen die Erfahrung so angenehm und unbeschwert.",
      "nep-agent": "Lizenzierter Immobilienmakler",
      "testimonials": "Meinungen unserer geschätzten Kunden",
      "moreabout": "Mehr zum Unternehmen",

      "from-offer": "Aktuell aus unserem Angebot",
      "didnt-find": "Nicht gefunden, wonach Sie gesucht haben?",
      "connect": "Verbinden Sie sich mit uns!",
      "tell-us": "Erzählen Sie uns von Ihren Immobilienwünschen",
      "we-are-sure": "Wir sind sicher",
      "you-will-be": "dass Sie mit unserem Service auf jeden Fall zufrieden sein werden, wie alle unsere bisherigen Kunden.",
      "call": "Anrufen",
      "send-us": "oder senden Sie ein ausgefülltes Kontaktformular.",
      "respond-to-you": "Wir antworten Ihnen gerne!"
    },
    "en": {
      "expert-advice": "We provide expert advice on<br><span style=\"font-weight:bold;\">selling, buying or renting</span><br>your dream property",
      "real-estate-search": "Looking for real estate?",
      "real-estate-sell": "Selling real estate?",
      "real-estate-rent": "Renting?",
      "contact": "CONTACT ME",
      "main-title": "Why choose<br>a real estate agent?",
      "main-title-line": "Why choose a real estate agent",
      "point1": "PROFESSIONAL KNOWLEDGE",
      "desc1": "We have in-depth knowledge of the real estate market,<br>legal processes and market trends.",
      "point2": "INDIVIDUAL APPROACH",
      "desc2": "We listen to the needs and wishes of our customers and adapt<br>our approach to achieve the best goals.",
      "point3": "PROFESSIONALISM",
      "desc3": "We ensure a high level of service and ensure that transactions<br>are carried out professionally and in accordance with the law.",
      "point4": "NETWORKING",
      "desc4": "We have access to a wide network of potential buyers and sellers,<br>which increases the chance of a successful transaction.",
      "point5": "TIME SAVING",
      "desc5": "We manage all sales or purchase processes, so you can<br>focus on other more important things.<br>We guide you through the entire process with professional support and advice.<br>We make the experience as pleasant and carefree.",
      "nep-agent": "Licenced real estate agent",
      "testimonials": "Opinions of our valued customers",
      "moreabout": "More about our company",
      "from-offer": "Currently from our offer",
      "didnt-find": "Didn't find what you were looking for?",
      "connect": "Connect with us!",
      "tell-us": "Tell us about your real estate wishes",
      "we-are-sure": "We are sure",
      "you-will-be": "that you will be satisfied with our service, like all our customers so far.",
      "call": "Call us",
      "send-us": "or send us the completed contact form.",
      "respond-to-you": "We will be happy to respond to you!"
    }
  }
</i18n>
